<template lang="pug">

  v-form(ref="form" v-model="valid" lazy-validation)
    v-card
      v-card-title
        span.headline {{ $tc('client.title', 1) }}
        v-spacer
        v-btn(icon @click="close"): v-icon close
      v-card-text
        v-container(grid-list-md)
          v-layout(wrap)
            v-flex(xs12)
              v-text-field(
                v-model="name"
                :label="$t('client.name')"
                :rules="rules.name"
                :error-messages="errors.name"
              )
      v-card-actions
        v-menu(v-if="data.id" auto)
          template(v-slot:activator="{ on }")
            v-btn(color="red" text v-on="on") {{ $t('ui.delete') }}
          v-list.error
            v-list-item(@click="remove"): v-list-item-title {{ $t('ui.are_you_sure') }}
        v-btn(text @click="close") {{ $t('ui.cancel') }}
        v-spacer
        v-btn(color="blue" text :disabled="!valid" @click="submit") {{ $t('ui.save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default{

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      valid: true,
      name: '',
      rules: {
        name: [
          v => !!v || this.$t('validation.required', { field: this.$t('client.name') }),
        ],
      },
      errors: {}
    }
  },

  watch: {
    name() {
      this.errors.name = undefined
    },
  },

  beforeMount() {
    this.name = this.data.name
  },

  methods: {
    ...mapActions('entities/clients', {
      createItem: 'createItem',
      updateItem: 'updateItem',
      deleteItem: 'deleteItem',
    }),
    close() {
      this.$emit('close')
    },
    submit() {
      if(this.$refs.form.validate()) {
        const data = {
          ...this.data,
          name: this.name,
        }
        let promise
        if(this.data.id) promise = this.updateItem(data)
        else             promise = this.createItem(data)
        promise
          .then(response => this.$emit('close'))
          .catch(failed => this.errors = failed.errors || {})
      }
    },
    remove() {
      this.deleteItem(this.data).then(response => this.$emit('close'))
    },
  },
}
</script>